<template>
  <div class="my_container">
    <none-view v-if="imLoading.loading" :login="imLoading.login" :loading="imLoading.loading" :text="imLoading.text" :data="list"></none-view>
    <div v-else class="my_im_box">
      <div class="my_im_left lf">
        <div class="my_im_search">
          <img src="../../assets/img/imBanner.png" alt="">
          <!-- <el-input
            placeholder="请输入内容"
            v-model="searchValue">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input> -->
        </div>
        <div class="my_im_user">
          <el-collapse v-model="userSlide" accordion>
           <el-collapse-item class="my_im_user_list" title="最近联系人" name="1">
           <div v-loading="userList.latelyLoading"
           element-loading-text="加载中"
           element-loading-spinner="el-icon-loading">
             <div class="my_im_user_item"
             v-for="item in userList.lately"
             :key="item.id"
             @click="getCurrentInfo(item.userProfile.userID, item.userProfile.nick, item.userProfile.avatar, '', item.unreadCount)">
               <div v-if="item.type === 'C2C'">
                 <div class="my_im_user_pic">
                   <img :src="item.userProfile.avatar" alt="头像">
                 </div>
                 <dl>
                   <dt class="my_im_user_name">{{item.userProfile.nick}}</dt>
                   <dd class="my_im_user_text">{{item.lastMessage.messageForShow}}</dd>
                 </dl>
                 <div class="my_im_user_time">{{getTime(item.lastMessage.lastTime)}}</div>
                 <div v-if="item.unreadCount > 0" class="my_im_user_num">{{item.unreadCount}}</div>
               </div>
             </div>
           </div>
           </el-collapse-item>
           <el-collapse-item class="my_im_user_list" title="关注的人" name="2">
            <div class="my_im_user_item"
            v-for="(item, index) in userList.follow"
            :key="item.id"
            @click="getCurrentInfo(item.user_id, item.user_name, item.portrait, index)">
              <div class="my_im_user_pic">
                <img :src="item.portrait" alt="头像">
              </div>
              <dl>
                <dt class="my_im_user_name">{{item.user_name}}</dt>
                <dd class="my_im_user_text">{{item.content}}</dd>
              </dl>
              <div class="my_im_user_time">{{getTime(item.add_time)}}</div>
             <div v-if="item.count > 0" class="my_im_user_num">{{item.count}}</div>
            </div>
           </el-collapse-item>
         </el-collapse>
       </div>
     </div>
     <div class="lf">
       <imright-view :info="currentMes"></imright-view>
     </div>
   </div>
  </div>
</template>

<script>
import loading from '../Public/none.vue'
import imRight from '../Public/imRight.vue'
export default {
  name: 'IM',
  components: {
    noneView: loading,
    imrightView: imRight
  },
  data () {
    return {
      imLoading: {
        login: true,
        loading: true,
        text: ''
      },
      userSlide: '1', // 用户左侧折叠面板默认打开
      currentUser: {}, // 当前登陆用户信息
      currentMes: {
        id: '', // 用户id
        name: '', // 用户名称
        pic: '', // 用户名称
        list: [], // 用户聊天列表
        onOff: false, // 是否到聊天列表底部
        page: 0, // 默认分页
        type: 'im'
      }, // 当前聊天
      list: {},
      userList: {
        lately: [], // 最近联系人
        latelyLoading: true, // 最近联系人加载动画
        follow: [] // 关注的人
      }, // 用户列表
      imList: {},
      searchValue: ''
    }
  },
  created () {
    const vueThat = this
    vueThat.currentUser = vueThat.$store.state.user.info
    if (vueThat.currentUser !== null) {
      vueThat.getMyfollowList()
      // 更新最新消息
      const onMessageReceived = async function (event) {
        const message = event.data[0]
        // 将最新消息更新到关注列表中
        if (vueThat.userList.follow.length > 0) {
          for (let i = 0; i < vueThat.userList.follow.length; i++) {
            if (parseInt(message.from) === vueThat.userList.follow[i].user_id) {
              vueThat.userList.follow[i].content = message.payload.text
              vueThat.userList.follow[i].add_time = message.time
              vueThat.userList.follow[i].count += 1
            }
          }
        }
        // 如果当前聊天id一致，将最新消息显示在当前聊天框中
        if (message.from === vueThat.currentMes.id + '') {
          vueThat.currentMes.list.push(message)
          vueThat.setMessageRead(1)
          vueThat.scrollToBottom()
        }
        vueThat.$store.commit('other/updateUnreadMessage', { type: 'add', num: 1 })
      }
      vueThat.webIM.on(vueThat.webIM.EVENT.MESSAGE_RECEIVED, onMessageReceived)
      vueThat.onLogin()
      vueThat.onSdkReady()
    }
  },
  // 离开页面销毁事件
  destroyed () {
    // 将当前聊天框重置
    this.currentMes = {
      id: '',
      name: '',
      pic: '',
      list: [],
      onOff: false,
      page: 0,
      type: 'im'
    }
  },
  methods: {
    // 登陆
    onLogin () {
      const vueThat = this
      const promise = vueThat.webIM.login({ userID: vueThat.currentUser.id + '', userSig: vueThat.currentUser.sig })
      promise.then(function (imResponse) {
        // 登陆成功
        vueThat.imLoading.loading = false
        if (imResponse.data.repeatLogin === true) {
          // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
          vueThat.getConversationList()
        }
      }).catch(function (imError) {
        vueThat.$alert('即时通讯登录错误，请重试！', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            vueThat.$router.go(-1)
          }
        })
      })
    },
    // 拉取最近联系人列表
    getConversationList () {
      const vueThat = this
      // 拉取会话列表
      const mesUserList = vueThat.webIM.getConversationList()
      mesUserList.then(function (imResponse) {
        vueThat.userList.latelyLoading = false
        const conversationList = imResponse.data.conversationList // 会话列表，用该列表覆盖原有的会话列表
        const mesArr = []
        for (let i = 0; i < conversationList.length; i++) {
          if (conversationList[i].type === 'C2C') {
            mesArr.push(conversationList[i])
          }
        }
        vueThat.userList.lately.push(...mesArr)
      }).catch(function (imError) {
        vueThat.$alert('获取最近联系人失败，请重试！', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            vueThat.$router.go(-1)
          }
        })
      })
    },
    // IM登陆为 ready 状态时触发
    onSdkReady () {
      const vueThat = this
      const onSdkReady = function (event) {
        vueThat.getConversationList()
      }
      vueThat.webIM.on(vueThat.webIM.EVENT.SDK_READY, onSdkReady)
    },
    // 获取关注的人
    getMyfollowList () {
      const vueThat = this
      vueThat.myApi.getMyFollowMessage().then((res) => {
        if (res.data.code === 200) {
          vueThat.userList.follow = res.data.data
        }
      })
    },
    // 获取当前聊天用户信息
    getCurrentInfo (id, name, pic, followIndex, num) {
      const vueThat = this
      vueThat.currentMes.id = id
      vueThat.currentMes.name = name
      vueThat.currentMes.pic = pic
      vueThat.currentMes.list = []
      // 打开某个会话时，第一次拉取消息列表
      vueThat.webIM.getMessageList({ conversationID: 'C2C' + vueThat.currentMes.id, count: 15 }).then(function (imResponse) {
        console.log(imResponse.data.messageList)
        vueThat.currentMes.list.push(...imResponse.data.messageList) // 消息列表。
        vueThat.currentMes.page = imResponse.data.nextReqMessageID // 用于续拉，分页续拉时需传入该字段。
        vueThat.currentMes.onOff = imResponse.data.nextReqMessageID // 表示是否已经拉完所有消息。
        vueThat.scrollToBottom()
      })
      vueThat.setMessageRead(num)
    },
    // 腾讯云IM已读消息上报
    setMessageRead (num) {
      const vueThat = this
      // 将某会话下所有未读消息已读上报
      vueThat.webIM.setMessageRead({ conversationID: 'C2C' + vueThat.currentMes.id }).then(function (imResponse) {
        // 已读上报成功，指定 ID 的会话的 unreadCount 属性值被置为0
        for (let i = 0; i < vueThat.userList.follow.length; i++) {
          if (vueThat.userList.follow[i].user_id === parseInt(vueThat.currentMes.id)) {
            vueThat.editReadMsg(vueThat.currentMes.id, i)
          } else {
            vueThat.editReadMsg(vueThat.currentMes.id)
          }
        }
        vueThat.$store.commit('other/updateUnreadMessage', { type: 'cut', num: num })
      }).catch(function (imError) {
        // 已读上报失败
        console.warn('setMessageRead error:', imError)
      })
    },
    // 平台已读消息上报
    editReadMsg (id, index) {
      const vueThat = this
      vueThat.myApi.editReadMsg({ user_id: id }).then((res) => {
        if (res.data.code === 200) {
          if (index !== undefined) {
            vueThat.userList.follow[index].count = 0
          }
        }
      })
    },
    // 过滤时间
    getTime (time) {
      if (time !== '') {
        return this.mycommon.getDate(time)
      }
    },
    // 始终在对话框最底部
    scrollToBottom () {
      this.$nextTick(() => {
        const div = document.getElementById('messageView')
        div.scrollTop = div.scrollHeight
      })
    }
  }
}
</script>

<style>
</style>
